<div class="alignContent">
    <viz-http-status code="404"></viz-http-status>
</div>
